export const resetV21RequestOptions = [
  'Immediate',
  'OnIdle',
  'ImmediateAndResume',
] as const;
export type ResetV21RequestOption = (typeof resetV21RequestOptions)[number];
